import { maxCategoryDepth } from "../../config/maxCategoryDepth.js";
import type { Category } from "../Category.js";

// Failsafe in case of weird family relations.
const recursionThreshold = maxCategoryDepth + 1;

export function getTopLevelCategory(
	categoryId: Category["id"],
	categories: Category[],
	depth = 0,
): Category | undefined {
	if (depth > recursionThreshold) {
		return undefined;
	}

	const category = categories.find(({ id }) => id === categoryId);

	if (category?.parentId) {
		return getTopLevelCategory(category.parentId, categories, depth++);
	}

	return category;
}
